module.exports = __webpack_public_path__ + "static/media/unlimitedGamesPlayed_500_1000.7551411a.png";